'use client';

import 'dayjs/locale/en';
import 'dayjs/locale/hy-am';
import 'dayjs/locale/ru';

import dayjs from 'dayjs';

import { useTranslate } from './use-locales';

type Props = {
  children: React.ReactNode;
};

export function LocalizationProvider({ children }: Props) {
  const { currentLang } = useTranslate();

  dayjs.locale(currentLang.dayjs);

  return <>{children}</>;
}
